import { EncryptionsAccessLogEventTypeEntity } from '../entities';
import { authResource } from './Auth';
export const EncryptionsAccessLogEventTypeResource = authResource({
    path: '/encryptions/accesslogs/eventtypes/:eventTypeId?',
    schema: EncryptionsAccessLogEventTypeEntity
});
